// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2l6gm","detailsBorder":"styles_detailsBorder__3cTYt"};